import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class LeadsService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/leads", { params: toSnakeCase(params) });
  }

  update(leadId, data) {
    return securedAxiosInstance.put(`/leads/${leadId}`, toSnakeCase(data));
  }

  disable(leadId) {
    return securedAxiosInstance.put(`/leads/${leadId}`, toSnakeCase({ status: "disabled" }));
  }
}

export default new LeadsService();
